import focusTrap from './focus-trap';
import { show as showOverlay, hide as hideOverlay, create as createOverlay } from './overlay';

export default class Openable {
  constructor(element, overlay, context) {
    if (typeof element === 'string' || element instanceof String) {
      this.container = document.querySelector(element);
    } else {
      this.container = element;
    }

    this.overlay = overlay;
    this.context = context;

    this.classes = {
      active: 'openable--active',
    };

    this.focusTrap = focusTrap(this.container);

    this.clickEvent = this.clickEvent.bind(this);
    this.keydownEvent = this.keydownEvent.bind(this);
    this.addEventListeners = this.addEventListeners.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.toggle = this.toggle.bind(this);

    if (this.overlay) {
      createOverlay('#shopify-section-header');
    }
  }

  addEventListeners() {
    document.addEventListener('click', this.clickEvent);
    document.addEventListener('keydown', this.keydownEvent);
    this.focusTrap.enable();
  }

  removeEventListeners() {
    document.removeEventListener('click', this.clickEvent);
    document.removeEventListener('keydown', this.keydownEvent);
    this.focusTrap.disable();
  }

  clickEvent(event) {
    // allows popups to work over modal without closing modal
    this.inclusions = [...document.querySelectorAll(`[data-context-include="${this.context}"]`)];

    const inclusionsContains = this.inclusions.filter((x) => x.contains(event.target));

    if (!inclusionsContains.length) {
      if (!this.container.contains(event.target) && !event.target.hasAttribute('data-active-label')) {
        event.stopPropagation();

        this.close();
      }
    }
  }

  keydownEvent(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  toggle() {
    if (this.container.classList.contains(this.classes.active)) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.container.setAttribute('aria-hidden', 'false');
    this.container.classList.add(this.classes.active);
    document.documentElement.style.overflow = 'hidden';

    this.dispatchEvent('open');

    if (this.overlay) showOverlay();

    setTimeout(this.addEventListeners, 1);
  }

  close() {
    this.container.setAttribute('aria-hidden', 'true');
    this.container.classList.remove(this.classes.active);
    document.documentElement.style.overflow = 'initial';

    if (this.overlay) hideOverlay();

    this.dispatchEvent('close');

    this.removeEventListeners();
  }

  dispatchEvent(type) {
    const event = new Event(type);

    this.container.dispatchEvent(event);
  }

  on(type, callback, options) {
    this.container.addEventListener(type, (event) => callback(event), options);
  }
}
